import * as React from 'react'
import { useBtcInfo } from '../../general/SatoshiPriceProvider';
import ChannelCountFilter from './ChannelCountFilter';
import NodeCapacityFilter from './NodeCapacityFilter';
import OnchainFeeInput from './OnchainFeeInput';


type Props = {
    onValueChange: (fitlers: Map<string, number>) => void,
}


const LiquidityAdFilterbar: React.FC<Props> = ({ onValueChange }: Props) => {
    const initialCapacitySat = 5 * 1000 * 1000;
    const initialChannelCount = 5;
    const initialOnChainFee = 1;
    const [filters, setFilters] = React.useState<Map<string, number>>(new Map([
        ['nodeCapacitySat', initialCapacitySat],
        ['nodeChannelCount', initialChannelCount],
        ['onchainSatPerVByte', initialOnChainFee]
    ]));

    const btcInfo = useBtcInfo();

    function changeFilter(property: string, value: number) {
        filters.set(property, value);
        setFilters(new Map(filters.entries()))
    }
    React.useEffect(() => {
        onValueChange(filters)
    }, [filters]);

    React.useEffect(() => {
        if (btcInfo?.transactionFeesSatPerVByte?.low) {
            changeFilter('onchainSatPerVByte', btcInfo.transactionFeesSatPerVByte.low);
        }
    }, [btcInfo])

    return (
        <div className='flex justify-end items-center flex-wrap'>
            <div className='flex items-center flex-wrap justify-end'>
                <span className='pr-2 text-gray-500 text-sm'>Filters:</span>
                <div className='pr-1'>
                    <NodeCapacityFilter
                        initialValue={initialCapacitySat}
                        onValueChange={function (newValue: number): void {
                            changeFilter('nodeCapacitySat', newValue);
                        }} />
                </div>

                <ChannelCountFilter
                    initialValue={initialChannelCount}
                    onValueChange={function (newValue: number): void {
                        changeFilter('nodeChannelCount', newValue);
                    }} />
            </div>
            <div className='flex items-center flex-wrap justify-end'>
                <span className='pr-2 pl-4 text-gray-500 text-sm'>Parameters:</span>
                <OnchainFeeInput
                    initialValue={initialOnChainFee}
                    onValueChange={function (newValue: number): void {
                        changeFilter('onchainSatPerVByte', newValue);
                    }} />
            </div>

        </div>
    );
}

export default LiquidityAdFilterbar;



